(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-information"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Detect mobile view
  if (window.innerWidth <= 767) {
    const firstTabButton = document.querySelector('.more-info-tabs__nav-link.mobile');
    const firstTabContent = firstTabButton ? document.querySelector('#' + firstTabButton.getAttribute('data-id')) : null;

    if (firstTabButton && firstTabContent) {
      // Add active/show classes to first tab on mobile
      firstTabButton.classList.add('active');
      firstTabContent.classList.add('show');
      firstTabContent.style.display = 'block';
    }
  }
});

  } catch(e) { console.error(e); }
})();
})();
